import request from '@/utils/request'


//附件地址  imgpath是参数
export function filePath(params) {
  return request({
    url: '/kxuser/user/getConfiguration/imgpath',
    method: 'get',
    params: params
  })
}

//级联地区
export function areaList(params) {
  return request({
    url:'/kxuser/area/listAll/',
    method:'get',
    params:params,
  })
}


//基础配置
export function queryBaseConfigList(params) {
  return request({
    url:'/kxuser/new_role/queryBaseConfigList',
    method:'get',
    params:params
  })
}

//新增配置
export function createBaseConfigInfo(data) {
  return request({
    url: '/kxuser/new_role/createBaseConfigInfo',
    method: 'post',
    data: data
  })
}

//修改配置
export function updateBaseConfigInfo(data) {
  return request({
    url: '/kxuser/new_role/updateBaseConfigInfo/',
    method: 'put',
    data: data
  })
}


//根据参数查询基础配置
export function querySconfigInfo(id,params) {
  return request({
    url:'/kxuser/sconfigInfo/querySconfigInfo/'+id,
    method:'get',
    params:params,
  })
}


// WEBPACK FOOTER //
// ./src/api/config.js